import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const SectionCaption = styled(Flex).attrs({
  row: true,
  justify: 'center',
  align: 'center',
})`
  height: 32px;
  width: 100%;
  color: #fff;
  background-color: #343a3d;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`;

export const SectionContainer = styled(Flex).attrs({
  width: '100%',
  height: 'calc(100% - 32px)',
  column: true,
  align: 'center',
  justify: 'center',
})`
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
`;
